<template>
    <Head title="Tambah Team" />
    <div class="row justify-content-md-center">
        <div class="card card-outline card-primary col-sm-6">
            <div class="card-header">
                <h3 class="card-title">TAMBAH TEAM</h3>
                <div class="card-tools">
                    <Link href="/team" class="btn btn-tool"><i class="fas fa-times"></i></Link>
                </div>
            </div>
            <form @submit.prevent="submit">
                <div class="card-body">
                    <input-select2 v-model="form.user_id" :error="form.errors.user_id" label="Penagihan"
                        :options="penagihans" :settings="{
                            placeholder: 'Pilih data ...',
                            allowClear: true,
                        }">
                    </input-select2>
                    <input-select2 v-model="form.team" :error="form.errors.team" label="Team" :options="kelompoks"
                        :settings="{
                            placeholder: 'Pilih data ...',
                            allowClear: true,
                        }">
                    </input-select2>
                </div>
                <div class="card-footer">
                    <button type="submit" class="btn btn-primary">
                        Simpan
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Layout from "@/Layouts/Master";
import { Head, Link } from "@inertiajs/vue3";
import InputSelect2 from "@/Forms/InputSelect2";

export default {
    layout: Layout,
    props: {
        penagihans: Array,
    },
    components: {
        Head,
        Link,
        InputSelect2,
    },
    data() {
        return {
            form: this.$inertia.form({
                user_id: "",
                team: "",
            }),
            kelompoks: [
                {
                    id: "TEAM A",text: "TEAM A",
                },
                {
                    id: "TEAM B",text: "TEAM B",
                },
                {
                    id: "TEAM C",text: "TEAM C",
                },
                {
                    id: "TEAM D",text: "TEAM D",
                },
                {
                    id: "TEAM E",text: "TEAM E",
                },
                {
                    id: "TEAM F",text: "TEAM F",
                },
                {
                    id: "TEAM G",text: "TEAM G",
                },
            ],
        };
    },
    methods: {
        submit() {
            this.form.post("/team", {
                preserveScroll: true,
                onSuccess: (page) => {
                    toastr.success("Tambah Team berhasil", "SUKSES");
                },
            });
        },
    },
};
</script>
